import React, { useState } from 'react';
import { Result } from 'antd';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LeadsList from "./pages/leads";
import ChatShow from "./pages/chats/show";
import './App.css';

function App() {
  return (<BrowserRouter>
    <Routes>
      {/* Rotas com id e uuid */}
      <Route path=":id/:uuid/leads" element={<LeadsList />} />
      <Route path=":id/:uuid/chats/:sessionId" element={<ChatShow />} />

      {/* Rota 404 para qualquer outra */}
      <Route path="*" element={<Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
      />} />
    </Routes>
  </BrowserRouter>)
}

export default App;
